<!-- Bell toggle -->
<button
  mat-icon-button
  (click)="openPanel()"
  #announcementsOrigin>
  @if (unreadCount > 0) {
    <span class="absolute top-0 right-0 left-0 flex items-center justify-center h-3">
      <span class="flex items-center justify-center shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-red-600 text-white text-xs font-medium">
        {{ unreadCount }}
      </span>
    </span>
  }
  <mat-icon [svgIcon]="'heroicons_outline:megaphone'"></mat-icon>
</button>

<!-- Panel -->
<ng-template #announcementsPanel>

  <div class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:min-w-120 sm:w-120 sm:rounded-2xl overflow-hidden shadow-lg">

    <!-- Header -->
    <div class="flex shrink-0 items-center py-4 pr-4 pl-6 bg-primary text-on-primary">
      <div class="sm:hidden -ml-1 mr-3">
        <button mat-icon-button (click)="closePanel()">
          <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
        </button>
      </div>
      <div class="text-lg font-medium leading-10">Announcements</div>
      <div class="ml-auto">
        @if (announcements && announcements.length) {
          <button
            mat-icon-button
            (click)="dismissAll($event)"
            [matTooltip]="'Dismiss all'">
            <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:check'"></mat-icon>
          </button>
        }
      </div>
    </div>

    <!-- Content -->
    <div class="relative flex flex-col flex-auto sm:max-h-[32rem] divide-y overflow-y-auto bg-card">

      @for (a of announcements; track trackByFn($index, a)) {
        <div class="flex group px-6 py-4 hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5"
          [ngClass]="{ 'sticky top-0 z-10 bg-card': a.severity === 'Critical' }">
          <!-- Severity badge -->
          <div class="flex shrink-0 items-center justify-center w-8 h-8 mr-4 rounded-full"
            [ngClass]="severityClasses(a.severity)">
            <mat-icon class="icon-size-5 text-current" [svgIcon]="severityIcon(a.severity)"></mat-icon>
          </div>
          <!-- Body -->
          <div class="flex flex-col flex-auto min-w-0">
            <div class="font-semibold">{{ a.title }}</div>
            @if (a.body) {
              <div
                class="mt-1 text-sm text-secondary prose prose-sm dark:prose-invert max-w-none break-words"
              [innerHTML]="a.body | markdown"></div>
            }
            @if (a.eventStartsAt) {
              <div class="mt-2 flex items-center text-xs text-secondary">
                <mat-icon class="icon-size-4 mr-1" [svgIcon]="'heroicons_outline:calendar'"></mat-icon>
                <span>{{ eventSubrow(a) }}</span>
                @if (eventEndTooltip(a)) {
                  <mat-icon
                    class="icon-size-4 ml-1 text-hint"
                    [svgIcon]="'heroicons_outline:information-circle'"
                  [matTooltip]="eventEndTooltip(a)"></mat-icon>
                }
              </div>
            }
          </div>
          <!-- Dismiss -->
          <div class="ml-2 flex items-start">
            <button mat-icon-button (click)="dismiss(a, $event)" [matTooltip]="'Dismiss'">
              <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
            </button>
          </div>
        </div>
      }

      <!-- Empty state -->
      @if (!announcements || !announcements.length) {
        <div class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8">
          <div class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100 dark:bg-primary-600">
            <mat-icon class="text-primary-700 dark:text-primary-50" [svgIcon]="'heroicons_outline:megaphone'"></mat-icon>
          </div>
          <div class="mt-5 text-2xl font-semibold tracking-tight">No announcements</div>
          <div class="w-full max-w-60 mt-1 text-md text-center text-secondary">
            New announcements will appear here.
          </div>
        </div>
      }

    </div>

  </div>

</ng-template>
